import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import GlobalHero from "@/pages/Home2/sections/GlobalHero";
import DualRoleCta from "@/pages/Home2/sections/DualRoleCta";
import Opportunities from "./sections/Opportunities";
import WhyHow from "./sections/WhyHow";
import NewsletterSignup from "./sections/NewsletterSignup";
import Testimonials from "./sections/Testimonials";
export default function HomePage() {
  return <div>
      <Header />
      <GlobalHero />
      <Opportunities />
      <WhyHow />
      <DualRoleCta />
      <NewsletterSignup />
      <Testimonials />
      <Footer />
    </div>;
}